module.exports = __webpack_public_path__ + "static/img/1.a76d08c.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner1/1.png
// module id = n4qs
// module chunks = 14